import { toast } from "react-toastify";

import axiosInstance from "../config/axiosInstance";

export const getProfiles = async (page = 1, pageSize = 10) => {
  try {
    const response = await axiosInstance.post("/user/beacons/profile/list", {
      page,
      pageSize,
    });

    if (response.data?.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    const data = {
      profiles: response.data.success.data,
      pagination: {
        page: response.data.page,
        pageSize: response.data.pageSize,
        nextPage: response.data.nextPage,
        foundCount: response.data.foundCount,
        totalCount: response.data.totalCount,
      },
    };

    return data;
  } catch (error) {
    if (error.response) {
      toast(error.response?.data?.error?.message || "Something went wrong", {
        type: "error",
      });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const getProfile = async (profileCode) => {
  try {
    const response = await axiosInstance.post("/user/beacons/profile/list", {
      profile_code: profileCode,
    });

    if (response.data?.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    const data = response.data.success.data[0];

    return data;
  } catch (error) {
    if (error.response) {
      toast(error.response?.data?.error?.message || "Something went wrong", {
        type: "error",
      });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const saveProfile = async (profileFields) => {
  try {
    const response = await axiosInstance.post(
      "/user/beacons/profile/save",
      profileFields
    );

    if (response.data && response.data.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    if (response.data && response.data.success) {
      toast("Profile saved", { type: "success" });

      if (response.data.success?.data?.profileCode) {
        return {
          acknowledged: true,
          profileCode: response.data.success?.data?.profileCode,
        };
      }
    }

    return { acknowledged: true };
  } catch (error) {
    if (error.response) {
      toast(error.message.toString(), { type: "error" });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const deleteProfile = async (id) => {
  try {
    const response = await axiosInstance.post("/user/beacons/profile/delete", {
      profile_code: id,
    });

    if (response.data && response.data.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    if (response.data && response.data.success) {
      toast(response.data.success.message, { type: "success" });
    }

    return { acknowledged: true };
  } catch (error) {
    if (error.response) {
      toast(error.message.toString(), { type: "error" });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const saveImage = async (id, image, name) => {
  try {
    const response = await axiosInstance.post("/user/beacons/upload-image", {
      fid: id,
      image,
    });

    if (response.data && response.data.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    return { acknowledged: true, id, name };
  } catch (error) {
    if (error.response) {
      toast(error.message.toString(), { type: "error" });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const getImage = async (id) => {
  try {
    const response = await axiosInstance.post("/user/beacons/view-image", {
      fid: id,
    });

    if (response.data && response.data.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    return response.data;
  } catch (error) {
    if (error.response) {
      toast(error.message.toString(), { type: "error" });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const deleteImage = async (id) => {
  try {
    const response = await axiosInstance.post("/user/beacons/delete-image", {
      fid: id,
    });

    if (response.data && response.data.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    return { acknowledged: true };
  } catch (error) {
    if (error.response) {
      toast(error.message.toString(), { type: "error" });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};

export const getProfileBeacons = async (page = 1, pageSize = 10, params) => {
  try {
    const response = await axiosInstance.post("/user/beacons/find", {
      page,
      pageSize,
      ...params
    });

    if (response.data?.error) {
      toast(response.data.error.message, { type: "error" });

      if (response.data.error?.data?.expired) {
        return {
          isTokenExpired: true,
        };
      }

      return null;
    }

    const data = {
      beacons: response.data.success.data,
      pagination: {
        page: response.data.page,
        pageSize: response.data.pageSize,
        nextPage: response.data.nextPage,
        foundCount: response.data.foundCount,
        totalCount: response.data.totalCount,
      },
    };

    return data;
  } catch (error) {
    if (error.response) {
      toast(error.response?.data?.error?.message || "Something went wrong", {
        type: "error",
      });
    } else if (error.request) {
      toast(error.message.toString(), { type: "error" });
    } else {
      toast(
        "Something happened in setting up the request that triggered an error",
        { type: "error" }
      );
    }

    return null;
  }
};